module.exports = __webpack_public_path__ + "img/wb_ic_arrow.89558b39.svg";